import { Competition } from "../../Widgets/Competition";

export const RelationshipsTemplate = ({ competitionForm, trendsForm }) => {
    return (
        <div className="border-t">
            <p className="p-3 font-bold border-b text-xl">Relationships</p>
            <div className="ml-16 border-l">
                <div>
                    <p className="p-3 font-bold border-b text-xl">Competition</p>
                    <section className="grid gap-0 items-center pt-4 pb-4">
                        <span className="top">{competitionForm.attributes[1]}</span>
                        <span className="left">{competitionForm.attributes[0]}</span>
                        <div className="center">
                            <Competition data={competitionForm}/>
                        </div>
                        <span className="right">{competitionForm.attributes[2]}</span>
                        <span className="bottom">{competitionForm.attributes[3]}</span>
                    </section>
                </div>
                <div>
                    <p className="p-3 font-bold border-t border-b text-xl">Trends</p>
                    <span className="font-bold pl-3 pt-3">Trends:</span>
                    <ul className="p-3 flex flex-col gap-6">
                        {trendsForm?.trends.map((el, index) => (
                            <li key={index}>{el?.trend}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}